export const LeadDescription ={
    
        "Organizer":'Conscientious, systematic, careful. Like working with data, paperwork, details. Like structure, clear instructions.',

        "Persuader":"Ambitious, competitive, energetic. Like leading, convincing, and managing people for economic gain.",

        "Creator":"Self-expression, creativity, imagination.Appreciates art, beauty, aesthetics, language — Unconventional people who think outside the box",

        "Doer":"Hands-on and practical. Physical or mechanical ability. Prefers working with objects, tools, machines, and animals and producing tangible results",

        "Thinker":"Analyze, observe, learn, evaluate, and solve abstract problems. Curious, independent, innovative. Likes science, research, and calculations.Prefers working with ideas using intellect",

        "Helper":"'Caring, responsible, warm. Like working with people-to inform, empower, inspire, train, or heal them"

}